export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mapbox-gl-csp-worker-43dc5845df6aa63dc5a4.worker.js");
}
